import GuidelinesPage from '../js/pages/GuidelinesPage';

export default GuidelinesPage;
